export default "/images/corner-up-right.svg?76ab27cbacb27b02e1aaefc6061c50e6";